<div *ngIf="isModalLoading" class="modal-spinner">
  <div class="spinner-border text-secondary" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>